<form #PasswordChangeForm="ngForm" autocomplete="off" (ngSubmit)="submit(PasswordChangeForm)">
  <div class="m-auto">
    <div class="p-grid">
      @if (!wasAnon) {
        <div class="p-col-12">
          <h1 class="title">Change Password</h1>
        </div>
      }
      @if (wasAnon) {
        <div class="p-col-12">
          <h1 class="title">Welcome</h1>
          <div>
            Welcome to the Russell Tree Experts Customer Online Portal! You can log in to review quotes, view schedule dates of upcoming work, view past work, update credit/debit card information, download receipts, and more! First, let’s start by creating a new password below!
          </div>
        </div>
      }
      <!-- <div class="p-col-12">
      <label for="username">Reset Code</label>
      <input class="form-control" name="username" type="text" [(ngModel)]="previousPassword" pInputText
        required>
      </div> -->
      <div class="p-col-12">
        <label for="password" class="m-top">New Password</label>
          <p-inputgroup>
            <input 
              class="form-control"
              name="password"
              #password="ngModel"
              [(ngModel)]="newPassword"
              pInputText
              required
              [ngClass]="{ 'is-invalid': submitted && password.invalid }"
              minlength="8"
              [type]="hidePassword ? 'password' : 'text'"
              tabindex="1"
            />
            <p-inputgroup-addon>
              <p-button type="button" [icon]="hidePassword ? 'pi pi-eye-slash' : 'pi pi-eye'" severity="info" (click)="hidePassword = !hidePassword"></p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
          <app-password-strength [passwordToCheck]="newPassword" (passwordStrength)="onPasswordStrengthChanged($event)"></app-password-strength>
        </div>
        <div class="p-col-12">
          <label for="password" class="m-top">New Password Confirmation</label>
          <p-inputgroup>
            <input
              class="form-control"
              name="confirmPassword"
              type="password"
              #confirmPassword="ngModel"
              [(ngModel)]="newPasswordConfirmed"
              pInputText
              required
              [ngClass]="{ 'is-invalid': submitted && confirmPassword.invalid }"
              minlength="8"
              [type]="hideConfirmPassword ? 'password' : 'text'"
              tabindex="2"
            />
            <p-inputgroup-addon>
              <p-button type="button" [icon]="hideConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" severity="info" (click)="hideConfirmPassword = !hideConfirmPassword"></p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
            <div>
              @if (newPasswordConfirmed?.length) {
                <ul class="no-bullets">
                  <li>@if (!passwordsMatch()) {
                    <span ><i class="pi pi-times"></i></span>
                    }@if (passwordsMatch()) {
                    <span ><i class="pi pi-check"></i></span>
                  }passwords must match</li>
                </ul>
              }
            </div>
          </div>
          <div class="p-col-12">
            <hr style="margin: 0;">
          </div>
          <div class="p-col-12">
            <p-button type="submit" severity="success"label="Submit" style="width: 100%;" [disabled]="saving || !strongPassword || !passwordsMatch()"
            tabindex="3"></p-button>
          </div>
          @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage"></p-message>
          }
        </div>
      </div>
    </form>